import * as React from 'react';
import { useIntl, useDispatch, useSelector } from '@grandvisionhq/state';
import { toggleInvoice } from '../actions.js';
import { getCompany, getShippingDetails } from '../selectors.js';
import { InvoiceForm } from '../components/InvoiceForm.js';
import { useFormSlot } from '../../slots/forms/form-context.js';

const InvoiceFormContainer = (props)=>{
    const { getLabel  } = useIntl();
    const dispatch = useDispatch();
    const company = useSelector(getCompany);
    const shippingData = useSelector(getShippingDetails);
    const { invoice  } = useFormSlot({
        onChange: props === null || props === void 0 ? void 0 : props.onChange
    });
    const invoiceFormData = shippingData && shippingData.invoice;
    React.useEffect(()=>{
        // Invoice is an optional form, whenever it's defined we need to enable it in our redux state
        if (invoice && !company && !(invoiceFormData === null || invoiceFormData === void 0 ? void 0 : invoiceFormData.isEnabled)) {
            dispatch(toggleInvoice({
                enabled: true
            }));
        }
        if (!invoice && (invoiceFormData === null || invoiceFormData === void 0 ? void 0 : invoiceFormData.isEnabled)) {
            dispatch(toggleInvoice({
                enabled: false
            }));
        }
    // objects returned by useFormSlot are not stable and will trigger rerenders
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        invoice
    ]);
    const labels = React.useMemo(()=>({
            invoiceTitle: getLabel('checkout.invoice.title')
        })
    , [
        getLabel
    ]);
    if (!invoice || company) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(InvoiceForm, {
        invoiceForm: invoice,
        title: labels.invoiceTitle
    });
};

export { InvoiceFormContainer };
//# sourceMappingURL=InvoiceFormContainer.js.map
